// extracted by mini-css-extract-plugin
module.exports = {"container":"PlanUsage_container__x2O0M","top":"PlanUsage_top__2ytlb","title":"PlanUsage_title__QCerS","details":"PlanUsage_details__3aoRn"};